// @ts-nocheck
import { useEffect, useState } from "react";
import { useInputContext } from "leva/plugin";
import { BezierSvg } from "../svg/BezierSvg";
import type { BezierProps, InternalBezier } from "../types/bezier-types";
import type { PresetObj, ToolApplyRequest } from "../types/general-types";
import { BezierPreview } from "./BezierPreview";
import { applyTool } from "../utilities/layers";
import { StyledButton } from "../styles/StyledButton";
import { StyledReturnButton } from "../styles/StyledReturnButton";
import { useGlobalState } from "../hooks/useGlobalState";
import { UITools } from "../types/context-types";
import { PresetModal } from "./PresetModal";
import {
	loadCustomPresets,
	saveCustomPresets,
	readKeyframePairEasingRequest,
	clearKeyframeEasingRequest,
} from "../utilities/layers";
import HoverModalButton from "./HoverModalButton";
import { HandlesModalButton } from "./HandlesModalButton";
import TopSection from "./TopSection";
import { DividerX } from "../styles/DividerX";
import { useNotifications } from "../context/NotificationProvider";
import { useStateCallback } from "../hooks/useStateCallback";
import HorizontalScroll from "./HorizontalScroll";
import { PresetsBezierBar } from "./PresetsBezierBar";
import IconNavArrowDown from "./icons/IconNavArrowDown";
import { buildToolPresets } from "../utilities/build-presets";
import { on } from "events";

export function Bezier() {
	const { addNotification } = useNotifications();
	const { label, value, displayValue, settings, onUpdate, setSettings } =
		useInputContext<BezierProps>();
	const { preview } = settings;
	const { configSettings, UIStatus, synergy, keysHeld } = useGlobalState();
	const [numFramesModal, setNumFramesModal] = useState(false);
	const [isInverted, setIsInverted] = useState(false);
	const [numFrames, setNumFrames] = useState(20);
	const [savePopup, setSavePopup] = useState(false);
	const [readKeyframePairValues, setReadKeyframePairValues] = useStateCallback(
		{}
	);
	const [presetBezierBarOpen, setPresetBezierBarOpen] = useState(false);
	const [presetBezierBarFull, setPresetBezierBarFull] = useState(false);
	const [presetRows, setPresetRows] = useState([]);
	const [bezierFavorites, setBezierFavorites] = useState([]);

	function applyDistributeHandler(reqValue): void {
		// if (synergy.display) {
		// 	let inEase, outEase;
		// 	for (let i = 0; i < defaultPresets.length; i++) {
		// 		if (defaultPresets[i].name === synergy.easeIn) {
		// 			inEase = defaultPresets[i].value;
		// 		}
		// 		if (defaultPresets[i].name === synergy.easeOut) {
		// 			outEase = defaultPresets[i].value;
		// 		}
		// 	}
		// 	if (!inEase || !outEase) {
		// 		alert("Please select an in and out ease");
		// 		return;
		// 	}
		// 	let req: ToolApplyRequest = {
		// 		tool: UITools.synergy,
		// 		values: value,
		// 		userVars: {
		// 			numFrames: numFrames,
		// 			isInverted: isInverted,
		// 			inEase: inEase,
		// 			outEase: outEase,
		// 		},
		// 		config: configSettings,
		// 	};
		// 	applyTool(req);
		// } else {
		let [x1, y1, x2, y2] = reqValue;
		let req: ToolApplyRequest = {
			tool: UITools.distribute,
			values: [x1, y1, x2, y2],
			userVars: { numFrames: numFrames, isInverted: isInverted },
			config: configSettings,
		};
		applyTool(req);
		// }
	}

	function buildBezierToolPresets() {
		buildToolPresets(UITools.bezier, setPresetRows, setBezierFavorites);
	}

	//Whenever we change to bezier, we want to get the state of the bezier tool from context
	useEffect(() => {
		onUpdate(UIStatus.bezierDisplayValue);
	}, [UIStatus.currentDisplay]);

	useEffect(() => {
		buildBezierToolPresets();
	}, []);

	async function applyBezierHandler(values: InternalBezier): void {
		// console.log(values);
		let req: ToolApplyRequest = {
			tool: UITools.bezier,
			values: values,
			userVars: {},
			config: configSettings,
		};
		const json = await applyTool(req);
		if (json) {
			const res = JSON.parse(json);
			if (!res.success) {
				addNotification({
					message: res.message,
					type: "error",
					title: "Error",
				});
				return;
			}
			// addNotification({ message: "", type: "success", title: "Success" });
		}
	}

	function toggleInvert(): void {
		setIsInverted(!isInverted);
	}

	//Pulls existing presets, if they exist, and adds the new preset to the array then saves.
	async function handleSaveNewPreset(
		presetName: string,
		presetSection: string
	): Promise<void> {
		if (presetName.length === 0) {
			setSavePopup(false);
			return;
		}
		let newPresetsArray: PresetObj[] = [];
		let newPreset: PresetObj = {
			section: presetSection,
			name: presetName,
			value: value,
			type: "bezier",
			isStandard: false,
			index: Math.floor(1000000 + Math.random() * 9000000),
		};
		loadCustomPresets().then((presets) => {
			if (presets) {
				//getting a string
				presets = JSON.parse(presets); //converting to array of objects
				//search presets array for preset with the same name as the new preset
				for (let i = 0; i < presets.length; i++) {
					if (presets[i].name === presetName) {
						addNotification({
							message: "Preset with that name already exists",
							type: "error",
							title: "Error",
						});
						return;
					}
				}
				//@ts-ignore
				newPresetsArray = presets;
				newPresetsArray.push(newPreset); //adding a new object
			}
			saveCustomPresets(newPresetsArray).then((res) => {
				if (res) {
					buildBezierToolPresets();
					addNotification({
						message: "Preset saved",
						type: "success",
						title: "Success",
					});
				} else {
					addNotification({
						message: "Error saving preset",
						type: "error",
						title: "Error",
					});
				}
			});
		});

		setSavePopup(false);
	}

	function handleNumFramesChange(operation: string) {
		if (operation === "add" && keysHeld.shift) setNumFrames(numFrames + 10);
		else if (operation === "subtract" && keysHeld.shift) {
			if (numFrames - 10 >= 1) setNumFrames(numFrames - 10);
		} else if (operation === "add") setNumFrames(numFrames + 1);
		else if (operation === "subtract")
			if (numFrames - 1 >= 1) setNumFrames(numFrames - 1);
	}

	function clearKeyframeEasing(): void {
		onUpdate([0.2, 0.2, 0.8, 0.8]);
		clearKeyframeEasingRequest().then((res) => {
			res = JSON.parse(res);
			if (!res.success) {
				addNotification({
					message: res.message,
					type: "error",
					title: "Error",
				});
				return;
			}
		});
	}

	function readKeyframePairEasing(): void {
		readKeyframePairEasingRequest().then((res) => {
			res = JSON.parse(res);
			if (!res.success) {
				addNotification({
					message: res.message,
					type: "error",
					title: "Error",
				});
				return;
			} else {
				setReadKeyframePairValues(res, (cb) => {
					onUpdate([cb.in.x, cb.in.y, cb.out.x, cb.out.y]);
				});
			}
		});
	}

	function deleteCustomPreset(presetName: string): void {
		let res: JSX.Element[] = [];
		loadCustomPresets().then((customPresets) => {
			customPresets = JSON.parse(customPresets);
			//@ts-ignore
			res = customPresets.filter(
				(preset: PresetObj) => preset.name !== presetName
			);
			//@ts-ignore
			saveCustomPresets(res).then(() => {
				buildBezierToolPresets();
			});
		});
	}

	function resetPreviewDuration(): void {
		let vals = readKeyframePairValues;
		vals.duration = 1;
		setReadKeyframePairValues(vals);
	}

	function handleModalToggle() {
		setNumFramesModal(!numFramesModal);
	}

	return (
		<>
			<TopSection setSavePopup={setSavePopup} />
			<div
				className={`relative flex-1 z-0 ${
					presetBezierBarFull && "border-t-[1px] border-elevation1"
				}`}
			>
				<BezierSvg
					clearKeyframeEasing={clearKeyframeEasing}
					displayValue={displayValue}
					onUpdate={onUpdate}
					withPreview={preview}
					resetPreviewDuration={resetPreviewDuration}
					isInverted={UIStatus.currentDisplay === "distribute" && isInverted}
					presetBezierBarFull={presetBezierBarFull}
				/>
			</div>
			{savePopup && (
				<PresetModal
					presets={presetRows}
					handleSaveNewPreset={handleSaveNewPreset}
				/>
			)}
			{/* Bottom Section */}
			<div className="flex flex-col items-center w-full mt-1.5 gap-0 z-50">
				<div className={`w-full ${presetBezierBarFull ? "hidden" : ""}`}>
					<BezierPreview
						value={value}
						readKeyframePairDuration={readKeyframePairValues.duration}
					/>
				</div>
				<div className="relative flex items-center w-full h-10 px-1.5 py-1 ">
					<HorizontalScroll className={`items-center`}>
						<div
							className={`flex f-full h-full ${
								presetBezierBarFull && "hidden"
							}`}
						>
							<HandlesModalButton
								type={"Out"}
								displayValue={displayValue}
								onUpdate={onUpdate}
							/>
							<HandlesModalButton
								type={"In"}
								displayValue={displayValue}
								onUpdate={onUpdate}
							/>
						</div>
						<div
							className={`flex h-full items-center ${
								presetBezierBarFull && "hidden"
							}`}
						>
							<DividerX />
						</div>
						{UIStatus.currentDisplay !== "distribute" ? (
							<HoverModalButton
								onClick={() => readKeyframePairEasing()}
								label="Read"
							/>
						) : (
							<div className="flex h-full">
								{/* <SynergyModalButton /> */}
								{/* <DividerX /> */}
								<HoverModalButton
									onClick={() => handleModalToggle()}
									label={`${numFrames}F`}
									modalAlign="left"
									// staticOn={true}
								>
									<div className="flex w-auto">
										<StyledButton
											style={{
												backgroundColor: "$elevation2",
												border: "none",
												fontSize: "20px",
											}}
											onClick={() => handleNumFramesChange("subtract")}
										>
											-
										</StyledButton>
										<StyledButton
											style={{
												backgroundColor: "$elevation2",
												border: "none",
												fontSize: "20px",
											}}
											onClick={() => handleNumFramesChange("add")}
										>
											+
										</StyledButton>
									</div>
								</HoverModalButton>
								<div className="flex-1" />
								<HoverModalButton
									onClick={() => toggleInvert()}
									label={"Flip"}
									staticOn={isInverted}
								/>
							</div>
						)}
					</HorizontalScroll>
					<div
						className={`relative flex flex-col items-center ml-1 h-full hover:bg-elevation3 cursor-pointer transition-colors duration-75 text-highlight2 mr-1 ${
							presetBezierBarOpen ? "bg-elevation3 rounded-t-md" : " rounded-md"
						}`}
					>
						<div
							onClick={() => {
								presetBezierBarOpen
									? setPresetBezierBarFull(true)
									: setPresetBezierBarOpen(true);
							}}
							className={`flex items-center transition-all duration-75 w-9 px-[8px] h-full rotate-180 ${
								presetBezierBarOpen ? " hover:bg-black rounded-b-md" : ""
							} 
							${presetBezierBarFull ? "opacity-0 hidden" : "opacity-1"}`}
						>
							<IconNavArrowDown />
						</div>
						<div
							onClick={() =>
								presetBezierBarFull
									? setPresetBezierBarFull(false)
									: setPresetBezierBarOpen(!presetBezierBarOpen)
							}
							className={`flex items-center transition-all duration-75 w-9 px-[8px] h-full ${
								presetBezierBarOpen
									? "opacity-1 hover:bg-black "
									: "opacity-0 hidden"
							} 
							${presetBezierBarFull ? "rounded-t-md" : ""}`}
						>
							<IconNavArrowDown />
						</div>
						<div
							className={`absolute top-full left-0 w-full h-[4px] bg-elevation3 -z-10 ${
								presetBezierBarOpen ? "" : "hidden"
							}`}
						/>
					</div>
					<StyledReturnButton
						onClick={() =>
							UIStatus.currentDisplay === "distribute"
								? applyDistributeHandler(value)
								: applyBezierHandler(value)
						}
					/>
				</div>
			</div>

			<PresetsBezierBar
				deleteCustomPreset={deleteCustomPreset}
				apply={
					UIStatus.currentDisplay === "distribute"
						? applyDistributeHandler
						: applyBezierHandler
				}
				presetRows={presetRows}
				setPresetRows={setPresetRows}
				setBezierFavorites={setBezierFavorites}
				// bezierFavorites={bezierFavorites}
				favorites={bezierFavorites}
				presetBezierBarOpen={presetBezierBarOpen}
				presetBezierBarFull={presetBezierBarFull}
			/>
		</>
	);
}
